module.exports = __webpack_public_path__ + "static/img/valuess-04.6f53f7f5.png";